<template>
<div class="card position-relative overflow-auto">
	<div class="dash-card-header"> 
		<div class="back-link ml-3">
			<!-- <button @click="hasHistory() ? $router.go(-1) : $router.push('/dashboard')">
				<img class="pull-left" src="@/assets/back.svg">	
			</button> -->
		</div>
		<div class="title-div font-semibold"><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t("New Password")}}</div>
	</div>		
	<div class="login-form">
		<!-- <div class="form-group">
			<input type="email" class="form-control bg-color-grblue-border" name="email" aria-describedby="emailHelp" placeholder="Email" v-model="form.email">
		</div> -->
		<div class="form-group">
			<input type="password" class="form-control bg-color-grblue-border" name="password" aria-describedby="emailHelp" placeholder="New Password" v-model="form.password">
		</div>
		<div class="form-group">
			<input type="password" class="form-control bg-color-grblue-border" name="passwordConfirm" aria-describedby="emailHelp" placeholder="Repeat Password" v-model="form.password_confirmation">
		</div>
		<div v-if="error"  class="form-group col-sm-12">
			<div class=" btn-danger p-8" ref="errormsg">{{error}}</div>
		</div>
		<div v-if="message"  class="form-group col-sm-12">
			<div class=" btn-success p-8" ref="errormsg">{{message}}</div>
		</div>
		<button @click="forgotPassword" type="submit" class="form-control btn bg-color-grblue">{{$t("save")}}</button>
	</div>
	<div class="bottom-txt-login col-sm-12"> 
		<div class="mb-5 p-4"> 
			<router-link :to="{name: 'login'}">{{$t("Back to Login")}}</router-link>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: "Forgot Password",
	data() {
		return{
			form:{
				password: '',
				email: this.$route.params.email,
				password_confirmation: '',
				token: this.$route.params.token
			},
			error: '',
			message: ''
		}
    },
	mounted() {
	},
    methods:{
		hasHistory () { return window.history.length > 2 },
        async forgotPassword(){ 
             this.error = null;
			 if (this.form.password != this.form.password_confirmation) {
				 this.error = 'Passwords dont match.'
				 return;
			 }
		
			await this.$store.dispatch('resetPassword', this.form).then(response => {
				console.log(response)
			}, error => {
				console.log(error)
			});
		
			await this.$router.push({ name: 'home' });
         },
    }
}

</script>